/* eslint-disable no-throw-literal */
import {
  CARDS_WRITE_COUNT,
  CARDS_GET_COUNT,
  CARDS_LIKE_COUNT,
  CARDS_GET_LIKE_COUNT,
  GET_MYCARD_LIST,
  GET_MYCARD_FAVORITE_LIST,
  GET_MYCARD_DETAIL,
  MYCARD_GET_SHOPS,
  MYCARD_SEARCH_USERS_BY_SHOP_ID,
  MYCARD_REGIST_FACING_TYPE_CARD,
  GET_BASE_DESIGN,
  GET_SHOP_NAME,
  CARD_LIKE_UPDATE,
  CARD_FAVORITE_UPDATE,
  CARD_CREATE,
  CARD_DELETE,
  CARD_UPDATE,
  CARD_NOT_ALREADY_READ_COUNT,
  GET_LAST_CARD,
  GET_UNREAD_ESMYCARD_EXIST,
  CARD_LIKE_LIST,
  PROBLEM_REPORT_UPDATE
} from './mutation-types'

export default {
  state: {
    cardData: {
      cards: [],
      last_month_date: '',
      next_exist: false,
      today: ''
    }
  },
  getters: {},
  actions: {
    async [CARDS_WRITE_COUNT] ({ dispatch }, params) {
      let data = {id: params.id}
      const res = await dispatch('apiGet', { url: '/asovi/cards/card_write_count', data: data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CARDS_GET_COUNT] ({ dispatch }, params) {
      let data = {id: params.id}
      const res = await dispatch('apiGet', { url: '/asovi/cards/card_get_count', data: data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CARDS_LIKE_COUNT] ({ dispatch }, params) {
      let data = {id: params.id}
      const res = await dispatch('apiGet', { url: '/asovi/cards/card_like_count', data: data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CARDS_GET_LIKE_COUNT] ({ dispatch }, params) {
      let data = {id: params.id}
      const res = await dispatch('apiGet', { url: '/asovi/cards/card_get_like_count', data: data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_MYCARD_LIST] ({ dispatch, state }, params) {
      if (params.isFirstLoad || !params.isBackPageSearch || state.cardData.length === 0) {
        const res = await dispatch('apiGet', { url: '/asovi/cards', data: params.data })
        if (res.status !== 200 && res.status !== 204) {
          throw {
            status: res.status
          }
        }
        if (params.isReadMore) {
          state.cardData = {
            cards: state.cardData.cards.concat(res.data.cards),
            last_month_date: res.data.last_month_date,
            next_exist: res.data.next_exist,
            today: res.data.today
          }
        } else {
          state.cardData = res.data
        }
      }
      return state.cardData
    },
    async [GET_MYCARD_FAVORITE_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/cards/get_favorites', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_UNREAD_ESMYCARD_EXIST] ({dispatch}, params) {
      const res = await dispatch('apiGet', {url: '/asovi/cards/get_unread_esmycard_exist'})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_MYCARD_DETAIL] ({ dispatch }, params) {
      const url = '/asovi/cards/get_card_detail/' + params.id
      const res = await dispatch('apiGet', { url: url })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [MYCARD_GET_SHOPS] ({ dispatch }) {
      const res = await dispatch('apiGet', { url: '/asovi/cards/get_shops' })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [MYCARD_SEARCH_USERS_BY_SHOP_ID] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/cards/search_users_by_shop_id', data: params })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data.data
    },
    async [MYCARD_REGIST_FACING_TYPE_CARD] ({ dispatch }, params) {
      const res = await dispatch('apiPost', { url: '/asovi/cards/regist_facing_type_card', data: params })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data.data
    },
    async [GET_BASE_DESIGN] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/cards/get_base_design', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_SHOP_NAME] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/cards/get_shop_name', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CARD_LIKE_UPDATE] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: '/asovi/cards/card_like_update', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CARD_FAVORITE_UPDATE] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: '/asovi/cards/card_favorite_update', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CARD_CREATE] ({ dispatch }, params) {
      const res = await dispatch('apiPost', { url: '/asovi/cards/', data: params })
      if (res.status === 200) {
        if (res.data.error) {
          return res.data.error
        }
      }
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data.data
    },
    async [CARD_DELETE] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: '/asovi/cards/' + params.data.card_id })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CARD_UPDATE] ({ dispatch }, params) {
      const url = '/asovi/cards/' + params.id
      const res = await dispatch('apiPatch', { url: url })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_LAST_CARD] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/cards/get_latest_card', data: params })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data.data
    },
    async [CARD_NOT_ALREADY_READ_COUNT] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/cards/not_already_read_count', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CARD_LIKE_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/card_likes', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [PROBLEM_REPORT_UPDATE] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: '/asovi/cards/problem_report_update', data: params })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/cards.js